import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/common/components/Button/Button';
import { Card } from '@/common/components/Card/Card';
import { Heading } from '@/common/components/Heading/Heading';
import { Icon } from '@/common/components/Icons/Icon';
import { Stack } from '@/common/components/Stack/Stack';

export type TProfileCardProps = {
  title?: ReactNode;
  onEdit?: () => void;
  children?: ReactNode;
};

export function ProfileCard({ title, onEdit, children }: TProfileCardProps) {
  const { t } = useTranslation();
  return (
    <Card plain className="grow">
      <Stack gap="section">
        <Stack horizontal justify="between">
          <Heading level={4}>{title}</Heading>
          {onEdit && (
            <Button
              variant="tertiary"
              size="sm"
              icon={<Icon icon="pencil" />}
              onPress={onEdit}
            >
              {t('dashboard.personal_info.edit')}
            </Button>
          )}
        </Stack>
        {children}
      </Stack>
    </Card>
  );
}
